// extracted by mini-css-extract-plugin
export default {"menuShadow":"sGFQOq","header":"cNFriI","title":"baVNVf","closeButton":"x9ycNK","buttonMenuPanel":"PH7HVS","item":"iGNg5n","link":"r7y4uI"};